import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useForm, useFormContext, FormProvider } from 'react-hook-form';
import { Modal, Image } from 'react-bootstrap';
import i18n from 'I18n';
import CloseIcon from '../../../assets/images/prompt_close_icon.svg';
import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import { PermissionCodes } from 'config/PermissionCodes';
import ContentSections from 'components/base/ContentSections';
import Loading from 'components/base/Loading';
import AuthButton from 'components/base/AuthButton';
import deleteImage from '../../../assets/images/deleteIcon.png';
import { CustomInput } from 'components/base/CustomTitleWithInput';
import ErrorFieldMessage, { hasError, ReactHookFormErrorMessage } from 'components/base/ErrorFieldMessage';
import { LevelErrorHandleFields } from './LevelErrorHandle';
import { ReactHookFormMarkDown } from 'components/base/CustomMarkDownArea';
import { LanguageConfig } from 'config/CustomEnums';
import './RetainMembershipTipsModal.scss';


const updateMembershipTipsValidate = ({
  getValues,
  setError,
  clearErrors
}) => {
  const titleField = "translations.en.title";
  const contentField = "translations.en.description";

  clearErrors([
    contentField
  ]);

  const [
    title,
    content,
  ] = getValues([
    titleField,
    contentField
  ]);

  let isValid = true;

  if (!title || !content) {
    isValid = false;
    setError(
      contentField,
      {
        type: 'require',
        message: LevelErrorHandleFields.titleAndContent,
      },
    );
  }

  return isValid;
};


const RetainMembershipTipsSection = ({
  language,
}) => {
  const {
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  const titleField = `translations.${language}.title`;
  const contentField = `translations.${language}.description`;

  const watchTitle = watch(titleField);
  const watchContent = watch(contentField);

  return (
    <>
      <div>
        <div className='retain-membership-tips-input-container'>
          <CustomInput
            onChange={({ target }) => {
              setValue(titleField, target.value, { shouldDirty: true, });
            }}
            value={watchTitle}
            inputCustomClass={"retain-membership-tips-title"}
            error={hasError(errors, contentField)}
          />
        </div>

        <ReactHookFormMarkDown
          content={{
            label: null,
            error:
              language === LanguageConfig.english
                ? hasError(errors, contentField)
                : false,
            key: contentField,
            focus: () => { },
          }}
        />
        <ReactHookFormErrorMessage
          errors={errors}
          id={contentField}
        />
      </div>
    </>
  );
}


const RetainMembershipTipsModal = ({
  languages,
  retainMembershipTipsLoading,
  retainMembershipTips,
  show,
  setShow,
}) => {
  const dispatch = useDispatch();

  const methods = useForm({
    mode: 'onChange',
    shouldFocusError: false,
    defaultValues: retainMembershipTips,
  });

  const { getValues, setError, clearErrors } = methods;

  useEffect(() => {
    dispatch({
      type: 'language/getList',
      payload: { isSelectorLoad: true }
    });
  }, [dispatch])

  useEffect(() => {
    if (show) {
      dispatch({
        type: 'levels/getRetainMembershipTips',
        payload: {},
      });
    }
  }, [dispatch, show]);

  useEffect(() => {
    methods.reset(retainMembershipTips);
  }, [dispatch, methods, retainMembershipTips])

  const onClose = () => {
    setShow(false);
    dispatch({
      type: 'levels/updateState',
      payload: {
        retainMembershipTipsLoading: false,
        retainMembershipTips: {},
      },
    })
  }

  const saveAction = () => {
    const isValid = updateMembershipTipsValidate({
      getValues,
      setError,
      clearErrors
    })

    if (!isValid) {
      return;
    };

    dispatch({
      type: 'levels/updateRetainMembershipTips',
      payload: {
        data: getValues(),
        afterAction: onClose,
      },
    })
  };

  const getTabs = (language) => {
    if (retainMembershipTipsLoading) {
      return [
        <Loading />,
      ]
    }
    return [
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit((data) => {
            console.log(data);
          })}
        >
          <RetainMembershipTipsSection
            language={language}
          />
        </form>
      </FormProvider>
    ];
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop='static'
    >
      <Modal.Body className={`base-prompt-container`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button"
          onClick={onClose}
        />
        <div className="first-section-title">Retain Membership</div>

        <div className='retain-membership-tips-container'>
          <ContentSections
            contentStyle='retain-membership-tips-sections'
            languageTabContent={{
              containers: languages?.map((item) => ({
                container: getTabs(item.code),
                key: item.code,
                title: item.sourceName,
              })),
            }}
            hidePreview
          />
        </div>

        <div className="base-prompt-buttons">
          <PromptButton
            title='Cancel'
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          <PromptButton
            title='Confirm'
            action={saveAction}
            requires={PermissionCodes.changeLevel}
            type={BUTTON_TYPES.main}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
  retainMembershipTipsLoading: state.levels.retainMembershipTipsLoading,
  retainMembershipTips: state.levels.retainMembershipTips,
});

export default connect(mapPropsToState)(RetainMembershipTipsModal);
